import { Component } from '@angular/core';
import { NowProvider } from 'app/modules/main/services/now-provider.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {

  readonly now = this.nowProvider.now();

  constructor(
    private readonly nowProvider: NowProvider,
  ) {
  }

}
